import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import { getFieldString } from 'data/transactions/searchFilter';
import { getAccountString } from 'data/accounts/retrievers';

const styles = (theme) => ({
  root: {
    padding: 6,
    boxShadow: `0px 0px 7px ${theme.palette.greyScale[4]}`,
  },
  textStyle: {
    color: 'black',
  },
  textStyleLeft: {
    overflow: 'hidden',
    whiteSpace: 'noWrap',
    textOverflow: 'ellipsis',
    extend: 'textStyle',
    flex: 2,
  },
  textStyleRight: {
    extend: 'textStyle',
    flex: 1,
    textAlign: 'right',
  },
  bottomRow: {
    fontSize: '12px',
    color: theme.palette.greyScale[2],
  },
});

class MiniTxnCard extends PureComponent {
  render() {
    const { classes, txn, ...props } = this.props;

    return (
      <div { ...props }>
        <div
          className={classes.root}
        >
          <div style={{ display: 'flex' }}>
            <Typography className={classes.textStyleLeft}> {txn.payee} </Typography>
            <Typography
              className={classes.textStyleRight}
            >
              {getFieldString('amount', txn)}
            </Typography>
          </div>
          <div style={{ display: 'flex' }}>
            <Typography className={classNames(classes.textStyleLeft, classes.bottomRow)}>
              {getAccountString(txn.accountId)}
            </Typography>
            <Typography
              className={classNames(classes.textStyleRight, classes.bottomRow)}
            >
              {getFieldString('date', txn)}
            </Typography>
          </div>
        </div>
      </div>
    )
  }
}

MiniTxnCard.propTypes = {
  classes: PropTypes.object.isRequired,
  txn: PropTypes.object,
};

export default compose(
  withStyles(styles)
)(MiniTxnCard);


